import * as React from 'react';
import * as moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import {
  getLocaleDateFormat,
  setDatePickerLocale,
  momentObjToFormattedString,
} from './util/date_picker_helper';

import './styles'
import {
  getSearchParams,
  getDefaultCheckinDateMoment,
  getDefaultCheckoutDateMoment,
  getTranslatedCheckin,
  getTranslatedCheckout,
  getTranslatedXNights,
} from '../helper/accommodation_helper';
class DatePickerUI extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      startDateMoment: null,
      endDateMoment: null,
      startDateFormattedString: '',
      endDateFormattedString: '',
      focusedInput: null,
      daysDiff: '',
    }
  }
  componentWillMount() {
    setDatePickerLocale();
    const searchParams = getSearchParams();
    if (searchParams.checkin_date && searchParams.checkout_date) {
      const checkinDateMoment = moment(searchParams.checkin_date as string)
      const checkoutDateMoment = moment(searchParams.checkout_date as string)
      this.setDateStates(checkinDateMoment, checkoutDateMoment);
    } else {
      const checkinDateMoment = getDefaultCheckinDateMoment();
      const checkoutDateMoment = getDefaultCheckoutDateMoment();
      this.setDateStates(checkinDateMoment, checkoutDateMoment);
    }
  }

  setDateStates(startDateMoment, endDateMoment) {
    let daysDiff = '?';
    if (startDateMoment && endDateMoment) {
      daysDiff = endDateMoment.diff(startDateMoment, 'days');
    }
    this.setState({
      startDateMoment,
      endDateMoment,
      startDateFormattedString: momentObjToFormattedString(startDateMoment),
      endDateFormattedString: momentObjToFormattedString(endDateMoment),
      daysDiff: daysDiff,
     });
  }

  onClickInputArea() {
    this.setState({
      focusedInput: 'startDate',
    });
  }

  closePicker(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.startDateMoment != null && this.state.endDateMoment == null) {
      const nextDayMoment = this.state.startDateMoment.clone().add(1, 'days');
      this.setDateStates(this.state.startDateMoment, nextDayMoment);
    }

    this.setState({
      focusedInput: null,
    });
  }

  render() {
    return (
      <React.Fragment>
        <input type="hidden" id="checkin" name="checkin_date" value={this.state.startDateFormattedString} />
        <input type="hidden" id="checkout" name="checkout_date" value={this.state.endDateFormattedString} />
        <div className="form-control sy_date_picker" onClick={this.onClickInputArea.bind(this)}>
          <DateRangePicker
            displayFormat={getLocaleDateFormat()}
            showDefaultInputIcon={false}
            inputIconPosition="before"
            customInputIcon={<i className="input_icon date_ico"></i>}
            hideKeyboardShortcutsPanel
            keepOpenOnDateSelect
            // showClearDates
            startDatePlaceholderText={getTranslatedCheckin()}
            endDatePlaceholderText={getTranslatedCheckout()}
            small
            block
            readOnly
            renderCalendarInfo={() =>
              <div style={{ width: '100%', height: 50 }}>
                <button
                  type="button"
                  className="btn"
                  style={{
                    display: 'block',
                    margin: '0 10px 0 auto'
                  }}
                  onClick={this.closePicker.bind(this)}>OK</button>
              </div>
            }
            numberOfMonths={1}
            startDate={this.state.startDateMoment} // momentPropTypes.momentObj or null,
            startDateId="checkin_picker" // PropTypes.string.isRequired,
            endDate={this.state.endDateMoment} // momentPropTypes.momentObj or null,
            endDateId="checkout_picker" // PropTypes.string.isRequired,
            onDatesChange={({ startDate, endDate }) => {
              this.setDateStates(startDate, endDate);
            }}
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
          />
          {/* <div style={{ position: 'absolute', left: 235, top: 10 }}>{`/ ${getTranslatedXNights(this.state.daysDiff)}`}</div> */}
        </div>
      </React.Fragment>
    );
  }
}

export default DatePickerUI;
